export const GET_EMERGENCY_REQUEST = "GET_EMERGENCY_REQUEST";
export const GET_EMERGENCY_SUCCESS = "GET_EMERGENCY_SUCCESS";
export const GET_EMERGENCY_FAILED = "GET_EMERGENCY_FAILED";